// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ePdZE","title":"styles_title__2UfIx","bubble":"styles_bubble__BF-Zm","img":"styles_img__2eeA-","whatElse":"styles_whatElse__3lCg7"};